
import React, { useRef } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'
import useGame from './stores/useGame'

export function Part(props) {
  const group = useRef()
  const { scene, nodes, materials, animations } = useGLTF('/part.glb')
  const { actions } = useAnimations(animations, group)
  const infoPanel = useGame((state) => state.infoPanel)
  
  if(actions['Scene'])
    {
        actions['Scene'].play()
    }

    scene.traverse( function( node ) {
      if ( node.isObject3D ) { node.castShadow = true; node.receiveShadow = true }
      
  } );


materials['Adapter_na_miedz'].metalness = 0.9
materials['Glowica_termostatyczna_SLIM'].metalness = 0.9
materials['Zawor_termostatyczny_katowy'].metalness = 0.9
materials['Zawor_termostatyczny_srodek'].metalness = 0.9
materials['gwinty'].metalness = 0.9
materials['krociec_srubunku'].metalness = 0.9
materials['logo_oraz_skala'].metalness = 0.9
materials['nakretka_odciecia'].metalness = 0.9
materials['nakretka_srubunku'].metalness = 0.9
materials['nakrtka_cylinder'].metalness = 0.9
materials['tarcza_nastawy_wstpnej'].metalness = 0.9
materials['zawor_by-passu'].metalness = 0.9



    

  
  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Sketchfab_Scene"
      castShadow
      receiveShadow>
        <group name="Sketchfab_model" rotation={[-Math.PI / 2, 0, 0]}
        castShadow
        receiveShadow>
          <group name="1c06fba6b75c4c9abc8b49e9fada8941fbx" rotation={[Math.PI / 2, 0, 0]}
          castShadow
          receiveShadow>
            <group name="Object_2"
            castShadow
            receiveShadow>
              <group name="RootNode"
              castShadow
              receiveShadow>
                <group
                castShadow
                receiveShadow
                  name="Armature001"
                  position={[2.8, 0.001, 5.066]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}>
                  <group name="Object_5">
                    <primitive object={nodes._rootJoint} />
                    <skinnedMesh
                      castShadow
                      receiveShadow
                      name="Object_21"
                      geometry={nodes.Object_21.geometry}
                      material={materials.Glowica_termostatyczna_SLIM}
                      skeleton={nodes.Object_21.skeleton}
                    />
                    <skinnedMesh
                      castShadow
                      receiveShadow
                      name="Object_23"
                      geometry={nodes.Object_23.geometry}
                      material={materials.logo_oraz_skala}
                      skeleton={nodes.Object_23.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_25"
                      geometry={nodes.Object_25.geometry}
                      material={materials.Glowica_termostatyczna_SLIM}
                      skeleton={nodes.Object_25.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_27"
                      geometry={nodes.Object_27.geometry}
                      material={materials.logo_oraz_skala}
                      skeleton={nodes.Object_27.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_29"
                      geometry={nodes.Object_29.geometry}
                      material={materials.Glowica_termostatyczna_SLIM}
                      skeleton={nodes.Object_29.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_31"
                      geometry={nodes.Object_31.geometry}
                      material={materials.nakretka_srubunku}
                      skeleton={nodes.Object_31.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_33"
                      geometry={nodes.Object_33.geometry}
                      material={materials.krociec_srubunku}
                      skeleton={nodes.Object_33.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_35"
                      geometry={nodes.Object_35.geometry}
                      material={materials.krociec_srubunku}
                      skeleton={nodes.Object_35.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_37"
                      geometry={nodes.Object_37.geometry}
                      material={materials.Adapter_na_miedz}
                      skeleton={nodes.Object_37.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_39"
                      geometry={nodes.Object_39.geometry}
                      material={materials.nakrtka_cylinder}
                      skeleton={nodes.Object_39.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_41"
                      geometry={nodes.Object_41.geometry}
                      material={materials.nakretka_odciecia}
                      skeleton={nodes.Object_41.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_43"
                      geometry={nodes.Object_43.geometry}
                      material={materials.krociec_srubunku}
                      skeleton={nodes.Object_43.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_45"
                      geometry={nodes.Object_45.geometry}
                      material={materials.krociec_srubunku}
                      skeleton={nodes.Object_45.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_47"
                      geometry={nodes.Object_47.geometry}
                      material={materials.nakretka_srubunku}
                      skeleton={nodes.Object_47.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_49"
                      geometry={nodes.Object_49.geometry}
                      material={materials.nakrtka_cylinder}
                      skeleton={nodes.Object_49.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_51"
                      geometry={nodes.Object_51.geometry}
                      material={materials.Adapter_na_miedz}
                      skeleton={nodes.Object_51.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_53"
                      geometry={nodes.Object_53.geometry}
                      material={materials.gwinty}
                      skeleton={nodes.Object_53.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_55"
                      geometry={nodes.Object_55.geometry}
                      material={materials.tarcza_nastawy_wstpnej}
                      skeleton={nodes.Object_55.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_57"
                      geometry={nodes.Object_57.geometry}
                      material={materials.Zawor_termostatyczny_srodek}
                      skeleton={nodes.Object_57.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_59"
                      geometry={nodes.Object_59.geometry}
                      material={materials.Zawor_termostatyczny_katowy}
                      skeleton={nodes.Object_59.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_61"
                      geometry={nodes.Object_61.geometry}
                      material={materials.Zawor_termostatyczny_katowy}
                      skeleton={nodes.Object_61.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_63"
                      geometry={nodes.Object_63.geometry}
                      material={materials.Zawor_termostatyczny_katowy}
                      skeleton={nodes.Object_63.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_65"
                      geometry={nodes.Object_65.geometry}
                      material={materials.Zawor_termostatyczny_katowy}
                      skeleton={nodes.Object_65.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_67"
                      geometry={nodes.Object_67.geometry}
                      material={materials.gwinty}
                      skeleton={nodes.Object_67.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_69"
                      geometry={nodes.Object_69.geometry}
                      material={materials.gwinty}
                      skeleton={nodes.Object_69.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_71"
                      geometry={nodes.Object_71.geometry}
                      material={materials['zawor_by-passu']}
                      skeleton={nodes.Object_71.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_73"
                      geometry={nodes.Object_73.geometry}
                      material={materials.tarcza_nastawy_wstpnej}
                      skeleton={nodes.Object_73.skeleton}
                    />
                    <skinnedMesh
                    castShadow
                    receiveShadow
                      name="Object_75"
                      geometry={nodes.Object_75.geometry}
                      material={materials.Zawor_termostatyczny_katowy}
                      skeleton={nodes.Object_75.skeleton}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_20"
                      position={[-8.5, 0, 0]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_22"
                      position={[-7.2, 0.012, 0.005]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_24"
                      position={[-8.5, 0, 0]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_26"
                      position={[-7.2, 0.001, -0.003]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_28"
                      position={[-8.5, 0, 0]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_30"
                      position={[-2.2, 4.552, 0.013]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_32"
                      position={[-2.2, 4.601, 0.016]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_34"
                      position={[-2.2, 4.601, 0.016]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_36"
                      position={[-2.2, 0.001, 5.066]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_38"
                      position={[-2.2, 0.001, 7.516]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_40"
                      position={[7.2, 0, 0]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_42"
                      position={[2.8, 4.601, 0.016]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_44"
                      position={[2.8, 4.601, 0.016]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_46"
                      position={[2.8, 4.552, 0.013]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_48"
                      position={[2.8, 0.001, 7.516]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_50"
                      position={[2.8, 0.001, 5.066]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_52"
                      position={[0.294, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_54"
                      position={[-4.45, 0.001, 0.001]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_56"
                      position={[0.304, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_58"
                      position={[-4.696, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_60"
                      position={[0.304, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_62"
                      position={[0.304, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_64"
                      position={[-4.696, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_66"
                      position={[0.294, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_68"
                      position={[0.294, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_70"
                      position={[0.3, 0.001, 0.816]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_72"
                      position={[-4.45, 0.001, 0.001]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                    <group
                    castShadow
                    receiveShadow
                      name="Object_74"
                      position={[0.304, 0, -0.335]}
                      rotation={[-Math.PI / 2, 0, 0]}
                      scale={100}
                    />
                  </group>
                </group>
                <group
                castShadow
                receiveShadow
                  name="Glowica_termostatyczna_SLIM_c001"
                  position={[-8.5, 0, 0]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="logo_oraz_skala_b001"
                  position={[-7.2, 0.012, 0.005]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="Glowica_termostatyczna_SLIM_a001"
                  position={[-8.5, 0, 0]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="logo_oraz_skala_a001"
                  position={[-7.2, 0.001, -0.003]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="Glowica_termostatyczna_SLIM_b001"
                  position={[-8.5, 0, 0]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="nakretka_srubunku_b001"
                  position={[-2.2, 4.552, 0.013]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="krociec_srubunku_02001"
                  position={[-2.2, 4.601, 0.016]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="krociec_srubunku_02_gwint001"
                  position={[-2.2, 4.601, 0.016]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="Adapter_na_miedz_02001"
                  position={[-2.2, 0.001, 5.066]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="nakr��tka_cylinder_02001"
                  position={[-2.2, 0.001, 7.516]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="nakretka_odciecia001"
                  position={[7.2, 0, 0]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="krociec_srubunku_01_gwint001"
                  position={[2.8, 4.601, 0.016]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="krociec_srubunku_01001"
                  position={[2.8, 4.601, 0.016]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="nakretka_srubunku_a001"
                  position={[2.8, 4.552, 0.013]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="nakr��tka_cylinder_01001"
                  position={[2.8, 0.001, 7.516]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="Adapter_na_miedz_01001"
                  position={[2.8, 0.001, 5.066]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="gwint_02001"
                  position={[0.294, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="tarcza_nastawy_wst��pnej_a001"
                  position={[-4.45, 0.001, 0.001]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="Zawor_termostatyczny_srodek001"
                  position={[0.304, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="gwint_01b001"
                  position={[-4.696, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="gwint_01a001"
                  position={[0.304, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="gwint_03a001"
                  position={[0.304, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="gwint_03b001"
                  position={[-4.696, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="sruba_odciecia001"
                  position={[0.294, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="gwint_04001"
                  position={[0.294, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="zawor_by-passu001"
                  position={[0.3, 0.001, 0.816]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="tarcza_nastawy_wst��pnej_b001"
                  position={[-4.45, 0.001, 0.001]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
                <group
                castShadow
                receiveShadow
                  name="Zawor_termostatyczny_katowy001"
                  position={[0.304, 0, -0.335]}
                  rotation={[-Math.PI / 2, 0, 0]}
                  scale={100}
                />
              </group>
            </group>
          </group>
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/part.glb')
